/* eslint-disable */
import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
    CCol,
    CForm,
	CFormLabel,
    CRow,
    CButton,
    CSpinner,
    CInputGroup,
    CInputGroupText,
} from "@coreui/react";
import Swal from "sweetalert";
import { useMutation, useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { FrontendAPI } from 'services';
import ReCAPTCHA from "react-google-recaptcha";
import { InputCV, CostumInput, Checkbox, ResponseError } from "components";
import { addCommas, removeNonNumeric } from "../../../../utils/formatRp";
import { useRouter } from 'next/router'; 

const ApplyJob = ({career, language, sexId, sexEn, maritalStatusId, maritalStatusEn, educationDegreeOption, lastJobDurationId, lastJobDurationEn }) => {
  const history = useRouter();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [CV, setCV] = useState("");
  const [nameFile, setNameFile] = useState("");

  const [recaptchaValue, setRecaptchaValue] = useState(null);
  // const [disabledGraduate, setDisabledGraduate] = useState(false);

  const {
      register,
      handleSubmit,
      formState: { errors, dirtyFields },
      control,
      setValue,
      } = useForm({
      mode: "onChange",
      defaultValues: {
        name: "",
        email: "",
        sex_id: [],
        marital_status_id: [],
        education_degree_id: [],
        last_job_duration_id: [],
        is_fresh_graduate: false,
        faculty_name: "",
        university_name: "",
        major_name: "",
        current_address: "",
        grade: "",
        company_name: "",
        city_name: "",
        expected_salary: "",
        last_position: "",
        statement: false,
        linkedin_url: "",
        portfolio_url: "",
        cv_file: "",
      },
  });

   // CREATE
   const { isLoading: isLoadingSendJobApplication, mutate: sendJobApplication } =
   useMutation(FrontendAPI.sendJobApplication, {
     onSuccess: (res) => {
      Swal("Success", "", "success");
      inputRef.current.value = null;
      setNameFile("");
      setCV("");
      setValue("cv_file", "");
      setValue("name", "");
      setValue("email", "");
      setValue("education_degree_id", []);
      setValue("last_job_duration_id", []);
      setValue("marital_status_id", []);
      setValue("sex_id", []);
      setValue("expected_salary", "");
      setValue("is_fresh_graduate", "");
      setValue("faculty_name", "");
      setValue("university_name", "");
      setValue("major_name", "");
      setValue("current_address", "");
      setValue("grade", "");
      setValue("company_name", "");
      setValue("city_name", "");
      setValue("last_position", "");
      setValue("dob", "");
      setValue("birth_place", "");
      setValue("statement", false);
      setValue("linkedin_url", "");
      setValue("portfolio_url", "");
      // setDisabledGraduate(false);
     },
     onError: (err) => {
      ResponseError(err, dispatch, history);
     },
   });

  useEffect(()=> {
    setValue("sex_id", []);
    setValue("marital_status_id", []);
    setValue("last_job_duration_id", []);
  },[language])

  const onSubmit = (data) => {
    Swal("Are you sure to send message?", {
      icon: "warning",
      dangerMode: true,
      buttons: {
        discard: {
          text: "Cancel",
          value: false,
        },
        save: {
          text: "Save",
          value: true,
        },
      },
    }).then((result) => {
      if (result) {
        if(recaptchaValue)
        {
          const formData = new FormData();
          formData.append("name", data.name);
          formData.append("email", data.email);
          formData.append("position", career?.position_name);
          formData.append("education_degree_id", data.education_degree_id.value);
          formData.append("marital_status_id", data.marital_status_id.value);
          formData.append("sex_id", data.sex_id.value);
          formData.append("expected_salary", data.expected_salary.replace(/[, ]+/g, "").trim());
          formData.append("is_fresh_graduate", data.is_fresh_graduate);
          formData.append("faculty_name", data.faculty_name);
          formData.append("university_name", data.university_name);
          formData.append("major_name", data.major_name);
          formData.append("current_address", data.current_address);
          formData.append("grade", data.grade);
          formData.append("dob", data.dob);
          formData.append("birth_place", data.birth_place);
          formData.append("cv_file", CV);
          if(data.last_job_duration_id.value)
          {
            formData.append("last_job_duration_id", data.last_job_duration_id.value);
          }
          if(data.last_position)
          {
            formData.append("last_position", data.last_position);
          }
          if(data.company_name)
          {
            formData.append("company_name", data.company_name);
          }
          if(data.city_name)
          {
            formData.append("city_name", data.city_name);
          }
          if(data.linkedin_url)
          {
            formData.append("linkedin_url", data.linkedin_url);
          }
          if(data.portfolio_url)
          {
            formData.append("portfolio_url", data.portfolio_url);
          }
          sendJobApplication(formData);
        }
      }
    });
  };

  const handleChange = (newValue, selectOption) => {
    const { action, name } = selectOption;

    if (action === "select-option") {
      setValue(name, newValue);
    } else if (action === "clear") {
        setValue(name, []);
    }
  };

  const handlechangeRecaptcha = (value) => {
    setRecaptchaValue(value);
  };

  const handleChangeSalary = (e) => {
    var data = parseInt(
      event.target.value.replace(/[, ]+/g, "").trim()
    );
    setValue("expected_salary", addCommas(removeNonNumeric(data)))
  }

  // const changeStatus = () => {
  //   setDisabledGraduate(!disabledGraduate);
  //   setValue("last_job_duration_id", []);
  //   setValue("company_name", "");
  //   setValue("city_name", "");
  //   setValue("last_position", "");
  // }

  return (
    <div className="content mb-5">
        <div className="col-our-office-location">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                    <h2>
                      {language === "EN" ? "Apply This Position" : "Lamar Posisi Ini" }
                    </h2>
                    </div>
                    <div className="col-md-12">
                    <CForm className="form-contact-us">
                        <CRow className="mt-3">
                            <CCol md={12}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Full Name" : "Nama Lengkap" }
                                name="name"
                                type="text"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-2">
                            <CCol md={12}>
                            <CostumInput
                                register={register}
                                label="Email"
                                name="email"
                                type="email"
                                errors={errors}
                                isReqMsg="Required"
                                patternMsg="Email is not valid"
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={6}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Place of Birth" : "Tempat Lahir" }
                                name="birth_place"
                                type="text"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                            <CCol md={6}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Date of Birth" : "Tanggal Lahir" }
                                name="dob"
                                type="date"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={6}>
                            <CostumInput
                            type="select"
                            controller={Controller}
                            control={control}
                            isClearable={true}
                            label={language === "EN" ? "Gender" : "Jenis Kelamin"}
                            name="sex_id.value"
                            handleSelect={handleChange}
                            register={register}
                            errors={errors}
                            isReqMsg="Required"
                            nameParent="sex_id"
                            dataSelect={language === "EN" ? sexEn : sexId}
                            />
                            </CCol>
                            <CCol md={6}>
                            <CostumInput
                              type="select"
                              controller={Controller}
                              control={control}
                              isClearable={true}
                              label={language === "EN" ? "Marital Status" : "Status Pernikahan"}
                              name="marital_status_id.value"
                              handleSelect={handleChange}
                              register={register}
                              errors={errors}
                              isReqMsg="Required"
                              nameParent="marital_status_id"
                              dataSelect={language === "EN" ? maritalStatusEn : maritalStatusId}
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={12}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Current Address" : "Domisili Saat Ini"}
                                name="current_address"
                                type="text"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={6}>
                              <CostumInput
                              type="select"
                              controller={Controller}
                              control={control}
                              isClearable={true}
                              label={language === "EN" ? "Last Education Degree" : "Tingkat Pendidikan Terakhir"}
                              name="education_degree_id.value"
                              handleSelect={handleChange}
                              register={register}
                              errors={errors}
                              isReqMsg="Required"
                              nameParent="education_degree_id"
                              dataSelect={educationDegreeOption}
                              />
                            </CCol>
                            <CCol md={6}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "University" : "Universitas" }
                                name="university_name"
                                type="text"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={6}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Faculty" : "Fakultas" }
                                name="faculty_name"
                                type="text"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                            <CCol md={6}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Major" : "Jurusan" }
                                name="major_name"
                                type="text"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={12}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Grade" : "IPK" }
                                name="grade"
                                type="grade"
                                errors={errors}
                                isReqMsg="Required"
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-2">
                        <CCol md={12}>
                        <h4>
                            {language === "EN" ? "Last Work Experience" : "Pengalaman Bekerja Terakhir" }
                        </h4>
                        </CCol>
                        </CRow>
                        <CRow className="mt-3">
                        <CCol md={12}>
                            <Checkbox
                            register={register}
                            label={"Fresh Graduate"}
                            name="is_fresh_graduate"
                            type="checkbox"
                            // onChange={changeStatus}
                            errors={errors}
                            />
                        </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={6}>
                            <CostumInput
                              register={register}
                              label={language === "EN" ? "Company Name" : "Nama Perusahaan" }
                              name="company_name"
                              type="text"
                              errors={errors}
                            />
                            </CCol>
                            <CCol md={6}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "City" : "Kota" }
                                name="city_name"
                                type="text"
                                errors={errors}
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={6}>
                            <CostumInput
                            type="select"
                            controller={Controller}
                            control={control}
                            isClearable={true}
                            label={language === "EN" ? "Last Job Duration" : "Lama Bekerja Terakhir"}
                            name="last_job_duration_id.value"
                            handleSelect={handleChange}
                            register={register}
                            errors={errors}
                            nameParent="last_job_duration_id"
                            dataSelect={language === "EN" ? lastJobDurationEn : lastJobDurationId}
                            />
                            </CCol>
                            <CCol md={6}>
                            <CostumInput
                              register={register}
                              label={language === "EN" ? "Last Position" : "Posisi Terakhir"}
                              name="last_position"
                              type="text"
                              errors={errors}
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={12}>
                            <CostumInput
                                register={register}
                                label={language === "EN" ? "Expected Salary" : "Ekspetasi Gaji"}
                                name="expected_salary"
                                type="salary"
                                errors={errors}
                                isReqMsg="Required"
                                handleChangeSalary={handleChangeSalary}
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-2">
                        <CCol md={12}>
                        <h4>
                            {"Links"}
                        </h4>
                        </CCol>
                        </CRow>
                        <CRow className="mt-3">
                            <CCol md={6}>
                            <CostumInput
                              register={register}
                              label={"Linkedin URL"}
                              name="linkedin_url"
                              type="text"
                              errors={errors}
                            />
                            </CCol>
                            <CCol md={6}>
                            <CostumInput
                              register={register}
                              label={"Portfolio URL"}
                              name="portfolio_url"
                              type="text"
                              errors={errors}
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-2">
                            <CCol md={12}>
                            <InputCV
                                errors={errors}
                                register={register}
                                label="Upload Resume"
                                CV={CV}
                                setCV={setCV}
                                name="cv_file"
                                nameFile={nameFile}
                                setNameFile={setNameFile}
                                setValue={setValue}
                                inputRef={inputRef}
                            />
                            </CCol>
                        </CRow>
                        <CRow className="mt-2">
                            <CCol md={12}>
                            <center>
                            <Checkbox
                                register={register}
                                label={language === "EN" ? "I declare that the information above is true" : "Saya menyatakan bahwa informasi diatas adalah benar"}
                                name="statement"
                                type="checkbox"
                                isReqMsg="Required"
                                errors={errors}
                            />
                            </center>
                            </CCol>
                        </CRow>
                        <CRow className="mt-2 align-items-center">
                            <CCol md={12}>
                                <center>
                                <ReCAPTCHA
                                ref={(e) => setRecaptchaValue(e?.props?.value ? e?.props?.value : null)}
                                name="recaptcha"
                                value={recaptchaValue}
                                sitekey="6LfDxzMiAAAAABYweb0eFCmROicEXyK9CFX6jVt6"
                                onChange={handlechangeRecaptcha}
                                />
                                </center>
                            </CCol>
                        </CRow>
                        <CRow className="mt-2">
                            <CCol md={12}>
                                <center>
                                <CButton
                                onClick={handleSubmit(onSubmit)}
                                disabled={recaptchaValue === null ? true : ""}
                                style={{
                                    width: "30%",
                                    background: "#0d6efd",
                                    boxShadow: "none",
                                }}
                                loading={isLoadingSendJobApplication}
                                >
                                    {language === "EN" ? "Apply Now" : "Lamar Sekarang" }
                                </CButton>
                                </center>
                            </CCol>
                        </CRow>
                    </CForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default ApplyJob;